import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-choice",
  "use": "icon-choice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-choice\"><defs><style></style></defs><path d=\"M863.576 208.934L426.32 673.53 128.084 464.78l-63.951 31.967 383.732 351.748 511.66-639.561z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol